/* eslint-disable max-len */
import React from "react"

import theme from "@irati/ui/src/global/theme"

import BaseSvgIcon from "../Base"

const Video = (props) => {
  const stroke = props?.color || theme.colors.greys.white
  return (
    <BaseSvgIcon {...props} viewBox="0 0 16 18">
      <path d="M15.3854 5.15381L10.7188 8.48714L15.3854 11.8205V5.15381Z" stroke={stroke} strokeWidth="1.28455" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M9.38542 3.8208H2.05208C1.3157 3.8208 0.71875 4.41775 0.71875 5.15413V11.8208C0.71875 12.5572 1.3157 13.1541 2.05208 13.1541H9.38542C10.1218 13.1541 10.7187 12.5572 10.7187 11.8208V5.15413C10.7187 4.41775 10.1218 3.8208 9.38542 3.8208Z" stroke={stroke} strokeWidth="1.28455" strokeLinecap="round" strokeLinejoin="round" />
    </BaseSvgIcon>
  )
}

export default Video
